// src/views/litellm/components/FreshnessTile.jsx
import React from "react";
import HeadlineKpiCard from "../../../components/ui-components/HeadlineKpiCard";
import { ageLabel } from "../format";

// FreshnessTile — the data-quality KPI. The label reads "Data freshness" (not "Ingestion", which
// paired with "15m ago" wasn't self-explanatory); the value is how long ago the last event
// arrived and the toned sub is the status word: Live (green) = an ingest within the last 10
// minutes, Stale (amber — a breached freshness threshold, not a hard failure, so amber not red),
// or No events (neutral) when nothing has been ingested yet.
export default function FreshnessTile({ freshness = {} }) {
  const hasEvents = freshness.latest_ingest_ts != null;
  const sub = !hasEvents ? "No events" : freshness.flowing ? "Live" : "Stale";
  const subTone = !hasEvents ? "text-text-3" : freshness.flowing ? "text-success" : "text-warning";

  return (
    <HeadlineKpiCard
      label="Data freshness"
      value={hasEvents ? ageLabel(freshness.seconds_since_latest) : "—"}
      sub={sub}
      subTone={subTone}
    />
  );
}
